import { useReducer } from "react";
import api from "../../api/schedule.js";

const intialState = {

};

function reducer(state, action) {
  switch (action.type) {
    default:
      return {
        ...state,
        ...action.payload
      };
  }
}

export default function useSchedMainInfoForm() {
  const [dataSources, dispatch] = useReducer(reducer, intialState);



  function getSchedMainInfoForm() {

  }

  return {
    dataSources,
    getSchedMainInfoForm
  };
}
